export default __webpack_public_path__ + "79dc14f164de849cbd251454ce9e1ac6.png";